import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFilmsListings, filmsListingsSelector } from '../../../LandingPage/LandingPage.duck';
import { CarouselSection, IconCollection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { LISTING_TYPE_FILMS } from '../../../../constants';
import { getListingEmptyCardData } from '../listingEmptyCardData';

const FilmsSection = ({ sectionName, description, currentUser }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const filmListings = useSelector(filmsListingsSelector);

  useEffect(() => {
    dispatch(fetchFilmsListings());
  }, []);

  const showMoreFilms = () => {
    history.push(createResourceLocatorString('FilmsPage', routeConfiguration, {}, {}));
  };

  const emptyCardData = getListingEmptyCardData({
    currentUser,
    listings: filmListings,
    listingType: LISTING_TYPE_FILMS,
    icon: <IconCollection icon="icon-film" />,
    intl,
    defaultTitleId: 'ListingEmptyCard.filmsTitle',
    defaultTextId: 'ListingEmptyCard.filmsText',
  });

  return filmListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={filmListings}
      handleAction={showMoreFilms}
      emptyCardData={emptyCardData}
    />
  ) : null;
};

export default FilmsSection;
